(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SubscriptionPackageCustom', SubscriptionPackageCustom);

    SubscriptionPackageCustom.$inject = ['$resource'];

    function SubscriptionPackageCustom($resource) {


        var getSubscriptionPackageByType = function (subscriptionType) {

            var resourceUrl = 'api/get-subscription-package-by-type?subscriptionType=' + subscriptionType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getSubscriptionPackageByPTypeAndSType = function (packageType, subscriptionType) {

            var resourceUrl = 'api/get-package-by-ptype-and-stype?subscriptionType=' + subscriptionType + '&packageType=' + packageType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getAllActiveSubscriptionPackages = function (packageType) {

            var resourceUrl = 'api/get-all-active-subscription-packages?packageType=' + packageType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getSubscriptionPackageByType: getSubscriptionPackageByType,
            getSubscriptionPackageByPTypeAndSType: getSubscriptionPackageByPTypeAndSType,
            getAllActiveSubscriptionPackages: getAllActiveSubscriptionPackages
        };
    }
})();
